import { Component, inject } from '@angular/core';
import { PageComponent } from '../../../infrastructure/shared/components/page/page';
import { ClientAppointmentsTable } from '../../../infrastructure/shared/components/client-appointments-table/client-appointments-table';
import { UserService } from '../../../infrastructure/shared/services/user.service';

@Component({
  standalone: true,
  selector: 'app-company-appointments-page',
  imports: [PageComponent, ClientAppointmentsTable],
  templateUrl: './company-appointments-page.html',
  styleUrl: './company-appointments-page.scss',
})
export class CompanyAppointmentsPage {
  private readonly _user = inject(UserService);

  userId = this._user.getUserData.id;
}
